import { useState, useEffect } from "react";
import Navbar, { scrollToSection } from "@/components/landing/Navbar";
import Footer from "@/components/landing/Footer";
import { Reveal } from "@/components/landing/Reveal";
import { Star } from "@/components/landing/Logo";
import Phygital from "@/components/landing/Phygital";
import { B2BScreens } from "@/components/landing/B2BScreens";
import { BoutiqueVideo } from "@/components/landing/VideoSections";
import B2B from "@/components/landing/B2B";
import Pricing from "@/components/landing/Pricing";
import Testimonials from "@/components/landing/Testimonials";
import FAQ from "@/components/landing/FAQ";
import CaseStudySection from "@/components/landing/CaseStudySection";
import WindowLooks from "@/components/landing/WindowLooks";
import B2BTeam from "@/components/landing/B2BTeam";
import B2BChallenges from "@/components/landing/B2BChallenges";
import B2BRoi from "@/components/landing/B2BRoi";
import { useLang } from "@/i18n/LanguageContext";

export default function Business() {
  const { t, lang } = useLang();
  const b = t.b2bPage;
  const [selectedPlan, setSelectedPlan] = useState(null);

  useEffect(() => {
    const s = new URLSearchParams(window.location.search).get("s");
    if (s) { setTimeout(() => scrollToSection(s), 600); setTimeout(() => scrollToSection(s), 1800); }
    else window.scrollTo(0, 0);
    const timer = setTimeout(() => {
      document.title = b.seoTitle;
      document.querySelector('meta[name="description"]')?.setAttribute("content", b.seoDesc);
    }, 120);
    return () => clearTimeout(timer);
  }, [b]);

  const handleSelectPlan = (plan) => {
    setSelectedPlan(plan);
    scrollToSection("boutiquen");
  };

  return (
    <main style={{ background: "var(--surface)", color: "var(--on-surface)" }} className="min-h-screen">
      <Navbar />

      <section className="mx-auto max-w-7xl px-5 sm:px-8 pt-36 pb-20 sm:pb-28" data-testid="b2b-hero">
        <div className="grid grid-cols-1 gap-14 lg:grid-cols-2 lg:items-center lg:gap-20">
          <div>
            <Reveal>
              <p className="flex items-center gap-2 text-xs uppercase font-medium" style={{ color: "var(--camel)", letterSpacing: "0.16em" }}>
                <Star size={11} /> {t.b2b.kicker}
              </p>
              <h1 className="mt-5 font-serif-display text-4xl sm:text-5xl lg:text-6xl font-semibold leading-tight" data-testid="b2b-hero-title">
                {b.heroTitle}
              </h1>
              <p className="mt-6 max-w-lg text-base md:text-lg leading-relaxed" style={{ color: "var(--muted-warm)" }}>
                {b.heroSub}
              </p>
              <div className="mt-9 flex flex-wrap items-center gap-4">
                <button
                  data-testid="b2b-hero-cta-demo"
                  onClick={() => scrollToSection("boutiquen")}
                  className="pill-btn rounded-full px-8 py-4 text-sm font-medium text-white"
                  style={{ background: "var(--camel)" }}
                >
                  {b.ctaDemo} →
                </button>
                <button
                  data-testid="b2b-hero-cta-pricing"
                  onClick={() => scrollToSection("preise")}
                  className="pill-btn rounded-full border px-8 py-4 text-sm font-medium transition-colors duration-300 hover:text-[var(--camel)]"
                  style={{ borderColor: "var(--camel)", color: "var(--on-surface)" }}
                >
                  {b.ctaPricing}
                </button>
              </div>
              <div className="mt-12 grid grid-cols-3 gap-4 max-w-lg" data-testid="b2b-hero-stats">
                {b.stats.map((s, i) => (
                  <div key={i} className="rounded-2xl border p-4" style={{ borderColor: "var(--line)", background: "var(--surface-secondary)" }}>
                    <p className="font-serif-display text-3xl font-semibold" style={{ color: "var(--camel)" }}>{s.v}</p>
                    <p className="mt-1 text-[11px] leading-snug" style={{ color: "var(--muted-warm)" }}>{s.l}</p>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>
          <Reveal delay={0.15} className="flex justify-center">
            <div className="w-72 sm:w-80 overflow-hidden rounded-[2.2rem] border-[7px] shadow-[0_50px_100px_-50px_rgba(198,156,109,0.6)]" style={{ borderColor: "#262119", background: "#262119" }}>
              <img src={`/app-screens/${lang}/kiosk.webp?v=5`} alt={b.heroTitle} className="w-full rounded-[1.7rem]" />
            </div>
          </Reveal>
        </div>
      </section>

      <B2BChallenges />

      <Phygital />

      <WindowLooks />

      <div className="mx-auto max-w-4xl px-5 sm:px-8" data-testid="b2b-screens-block">
        <B2BScreens />
        <BoutiqueVideo />
      </div>

      <B2BTeam />

      <B2B selectedPlan={selectedPlan} />
      <Pricing onSelectPlan={handleSelectPlan} />

      <B2BRoi />
      <CaseStudySection />
      <Testimonials mode="b2b" />
      <FAQ variant="b2b" />
      <Footer />
    </main>
  );
}
